import { h } from "harmaja"
import * as L from "lonna"
import { groupSelected, ungroupSelected } from "../item-group"
import { SubmenuProps } from "./ContextMenuView"
import { canMove } from "../board-permissions"

// ponytail: inline icons, replace when the menu gets designed
const GroupIcon = () => (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="3" width="18" height="18" rx="2" stroke-dasharray="3 2" />
        <rect x="7" y="7" width="4" height="4" fill="currentColor" />
        <rect x="13" y="13" width="4" height="4" fill="currentColor" />
    </svg>
)
const UngroupIcon = () => (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="3" width="8" height="8" rx="1" />
        <rect x="13" y="13" width="8" height="8" rx="1" />
    </svg>
)

export function groupMenu({ board, focusedItems, dispatch }: SubmenuProps) {
    const state = L.view(focusedItems, (f) => {
        const movable = f.items.filter(canMove)
        return { canGroup: movable.length >= 2, grouped: movable.some((i) => !!i.groupId) }
    })
    return L.view(state, ({ canGroup, grouped }) =>
        !canGroup && !grouped
            ? []
            : [
                  <div className="icon-group grouping">
                      {grouped ? (
                          <span
                              className="icon"
                              title="Ungroup (Cmd/Ctrl-Shift-G)"
                              onClick={() =>
                                  ungroupSelected(
                                      board.get(),
                                      {
                                          status: "selected",
                                          itemIds: new Set(focusedItems.get().items.map((i) => i.id)),
                                          connectionIds: new Set(),
                                      },
                                      dispatch,
                                  )
                              }
                          >
                              <UngroupIcon />
                          </span>
                      ) : (
                          <span
                              className="icon"
                              title="Group (Cmd/Ctrl-G)"
                              onClick={() =>
                                  groupSelected(
                                      board.get(),
                                      {
                                          status: "selected",
                                          itemIds: new Set(focusedItems.get().items.map((i) => i.id)),
                                          connectionIds: new Set(),
                                      },
                                      dispatch,
                                  )
                              }
                          >
                              <GroupIcon />
                          </span>
                      )}
                  </div>,
              ],
    )
}
